import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/30 to-transparent" data-id="element-235" data-mp="3udf8az5tp7i7" />

      <section className="relative py-32 px-6 bg-hero-gradient overflow-hidden flex items-center justify-center text-center" data-id="element-236" data-mp="c7tv9kju0su1">
        {/* Animated Gradient Mesh Background */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-237" data-mp="m4f1uabi2bzz">
          <div className="absolute top-0 left-0 w-full h-full bg-dark-bg/50" data-id="element-238" data-mp="m2vkege3xuwm" />
          <motion.div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple/30 rounded-full blur-[100px]" animate={{
          x: [0, 50, 0],
          y: [0, 30, 0]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-239" data-mp="h5c6jhlbnk57" />
          <motion.div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal/20 rounded-full blur-[100px]" animate={{
          x: [0, -40, 0],
          y: [0, -50, 0]
        }} transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-240" data-mp="zx4pej6ofoz7" />
        </div>

        {/* Floating Particles */}
        {[...Array(4)].map((_, i) => <motion.div key={i} className="absolute w-2 h-2 bg-white/20 rounded-full pointer-events-none" style={{
        left: `${20 + i * 20}%`,
        top: `${30 + i * 15}%`
      }} animate={{
        y: [0, -30, 0],
        opacity: [0.2, 0.5, 0.2]
      }} transition={{
        duration: 3 + i,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: i * 0.5
      }} data-id="element-241" data-mp="2qzujlq9wdi2p" data-mpi={i} />)}

        <div className="inner-container relative z-10 max-w-3xl" data-id="element-242" data-mp="3isld3t074so9">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-243" data-mp="3iqqrech3owj4">
            <h2 className="font-poppins font-extrabold text-5xl md:text-6xl mb-6 leading-tight" data-id="element-244" data-mp="1shycrx9yah5y">
              Ready to get your life back?
            </h2>
            <p className="text-xl md:text-2xl text-steel mb-10 font-inter" data-id="element-245" data-mp="22ebe9hbqlzb9">
              MIndSTReam.ing — Your business, running itself.
            </p>

            <button className="btn-primary text-lg px-10 py-5 mb-6 shadow-[0_0_40px_rgba(124,58,237,0.4)] hover:shadow-[0_0_60px_rgba(124,58,237,0.6)] transition-shadow" data-id="element-246" data-mp="1xhufzuatq4kg">
              Talk to MR Now →
            </button>

            <p className="text-sm text-steel/70 font-medium" data-id="element-247" data-mp="h1i1mg5fimow">
              No contracts. No setup fees. Strategy call included.
            </p>
          </motion.div>
        </div>
      </section>
    </>;
}